var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loja-perfeita-form-control-loading-wrap position-relative w-100",class:{ 'loja-perfeita-form-control-loading-wrap--busy': _vm.busy }},[_vm._t("default"),(_vm.busy)?_c('b-spinner',{staticClass:"loja-perfeita-form-control-loading-wrap__spinner",attrs:{"small":"","variant":"primary","aria-label":_vm.spinnerLabel}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }